import { createRoute } from "@tanstack/react-router";
import { customerLayoutRoute } from "../Dashboard";

export const brandingRoute = createRoute({
  getParentRoute: () => customerLayoutRoute,
  path: "branding",
}).lazy(() => import("./Branding.lazy").then((d) => d.Route));
